import axios from "axios";
import { newApiBaseUrl } from "../../axiosInstance";

const pgwHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `bearer ${localStorage.jwtToken}`,
  "X-Tenant": "hamazon",
});

export const getTransactionsByOrder = (orderId) =>
  axios.get(`${newApiBaseUrl}/transactions`, {
    headers: pgwHeaders(),
    params: { orderId: String(orderId) },
  });

export const getTransactionsByOrders = (orderIds) =>
  axios.post(
    `${newApiBaseUrl}/transactions/by-orders`,
    {
      orderIds: orderIds.map((id) => String(id)),
    },
    { headers: pgwHeaders() },
  );

export const parseTransactionsResponse = (data) => {
  if (Array.isArray(data?.transactions)) return data.transactions;
  if (Array.isArray(data)) return data;
  return [];
};

/** PGW POST /transactions/by-orders: flat map orderId → transaction[]. */
export const parseTransactionsByOrdersResponse = (data) => {
  if (!data || typeof data !== "object" || Array.isArray(data)) return {};
  if (data.byOrderId != null && typeof data.byOrderId === "object") {
    return data.byOrderId;
  }
  const map = {};
  for (const [key, value] of Object.entries(data)) {
    if (Array.isArray(value)) map[key] = value;
  }
  return map;
};

export const formatSingleTransaction = (tx) => {
  if (!tx || typeof tx !== "object") return null;
  const status =
    tx.status ||
    (tx.tenant_status ? String(tx.tenant_status).replace(/^[^-]+-/, "") : "");
  const digits = tx.last_four_digits ?? tx.lastFourDigits;
  const sum = tx.sum ?? tx.amount;
  const parts = [];
  if (status) parts.push(status);
  if (digits) parts.push(`****${digits}`);
  if (sum != null) parts.push(`₪${sum}`);
  return parts.length ? parts.join(" · ") : null;
};

export const getTransactionPaymentLabel = (transactions, fallback) => {
  if (!Array.isArray(transactions) || !transactions.length) {
    return fallback ?? null;
  }

  const latest =
    [...transactions].reverse().find((tx) => formatSingleTransaction(tx)) ??
    transactions[0];
  return formatSingleTransaction(latest) ?? fallback ?? null;
};
